import notEnabledImage from 'assets/images/cms/tiers-not-enabled.png'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'

const t = buildTranslate('cms.brand.tiers.not_enabled_page')

const NotEnabledPage: React.FC = () => {
  return (
    <CmsPage
      title={t('title')}
      description={t('description')}
      contactButtonTitle={t('contact_our_team')}
    >
      <img
        className="mb-l max-width-100"
        src={notEnabledImage}
        alt={t('image_alt')}
      />
    </CmsPage>
  )
}

export default NotEnabledPage
